// extracted by mini-css-extract-plugin
module.exports = {"revoke__warning":"style_revoke__warning__23-hp","revoke__btns":"style_revoke__btns__ueIpj"};